// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export enum AccountType
{
    SingleCCY = 0,
    MultiAsset = 1,
    ClosedFund = 2,
    OpenedFund = 3
}